import colors from "tokens/build/js/semantic-colors";
import { coreColors } from "tokens/build/js/core-colors";

export type CUICoreColorType = typeof coreColors[number];

export const semanticColors = colors;
export const semanticColorKeys = [
    "fg-default",
    "fg-moderate",
    "fg-subtle",
    "fg-minimal",
    "fg-inverse",
    "fg-primary",
    "fg-primary-strong",
    "fg-primary-minimal",
    "fg-global-black",
    "fg-global-white",
    "fg-focus",
    "fg-focus-inverse",
    "bg-base",
    "bg-default",
    "bg-layer-one",
    "bg-layer-two",
    "bg-layer-three",
    "bg-primary",
    "bg-primary-strong",
    "bg-primary-minimal",
    "highlight-accent",
    "highlight-brand",
    "highlight-one",
    "highlight-two",
    "highlight-three",
    "highlight-four",
    "status-positive-minimal",
    "status-positive",
    "status-positive-strong",
    "status-negative-minimal",
    "status-negative",
    "status-negative-strong",
    "status-notification-minimal",
    "status-notification",
    "status-notification-strong",
    "status-informational-minimal",
    "status-informational",
    "status-informational-strong",
    "status-alert-minimal",
    "status-alert",
    "status-alert-strong",
    "rewards-background"
] as const;

export type SemanticColorStatusType = "status-positive" |
"status-negative" |
"status-notification" |
"status-alert";

export type SemanticColorRewardsType = "rewards-background";

export type SemanticColorHighlightType = 
"highlight-accent" |
"highlight-brand" |
"highlight-one" |
"highlight-two" |
"highlight-three" |
"highlight-four";

export type SemanticColorFgType = "fg-default" |
"fg-moderate" |
"fg-subtle" |
"fg-minimal" |
"fg-inverse" |
"fg-primary" |
"fg-primary-strong" |
"fg-primary-minimal" |
"fg-global-black" |
"fg-global-white" |
"fg-focus" |
"fg-focus-inverse" 
;

export type SemanticColorBgType = "fg-default" |
"bg-base" |
"bg-default" |
"bg-layer-one" |
"bg-layer-two" |
"bg-layer-three" |
"bg-primary" |
"bg-primary-strong" |
"bg-primary-minimal";

export type SemanticColorType = SemanticColorFgType | SemanticColorBgType | SemanticColorHighlightType | SemanticColorStatusType | SemanticColorRewardsType;

export const tailwindSemanticColors: Record<SemanticColorType | string, string> = {
    "fg-default": "cui-text-fg-default",
    "fg-moderate": "cui-text-fg-moderate",
    "fg-subtle": "cui-text-fg-subtle",
    "fg-minimal": "cui-text-fg-minimal",
    "fg-inverse": "cui-text-fg-inverse",
    "fg-primary": "cui-text-fg-primary",
    "fg-primary-strong": "cui-text-fg-primary-strong",
    "fg-primary-minimal": "cui-text-fg-primary-minimal",
    "fg-global-black": "cui-text-fg-global-black",
    "fg-global-white": "cui-text-fg-global-white",
    "fg-text-link": "cui-text-fg-text-link",
    "fg-focus": "cui-text-fg-focus",
    "fg-focus-inverse": "cui-text-fg-focus-inverse",
    "bg-base": "cui-text-bg-base",
    "bg-default": "cui-text-bg-default",
    "bg-layer-one": "cui-text-bg-layer-one",
    "bg-layer-two": "cui-text-bg-layer-two",
    "bg-layer-three": "cui-text-bg-layer-three",
    "bg-primary": "cui-text-bg-primary",
    "bg-primary-strong": "cui-text-bg-primary-strong",
    "bg-primary-minimal": "cui-text-bg-primary-minimal",
    "highlight-accent": "cui-text-highlight-accent",
    "highlight-brand": "cui-text-highlight-brand",
    "highlight-one": "cui-text-highlight-one",
    "highlight-two": "cui-text-highlight-two",
    "highlight-three": "cui-text-highlight-three",
    "highlight-four": "cui-text-highlight-four",
    "status-positive": "cui-text-status-positive",
    "status-negative": "cui-text-status-negative",
    "status-notification": "cui-text-status-notification",
    "status-alert": "cui-text-status-alert",
    "rewards-background": "cui-text-rewards-background"
}

export const tailwindSemanticBgColors: Record<SemanticColorType | string, string> = {
    "bg-base": "cui-bg-bg-base",
    "bg-default": "cui-bg-bg-default",
    "bg-layer-one": "cui-bg-bg-layer-one",
    "bg-layer-two": "cui-bg-bg-layer-two",
    "bg-layer-three": "cui-bg-bg-layer-three",
    "bg-primary": "cui-bg-bg-primary",
    "bg-primary-strong": "cui-bg-bg-primary-strong",
    "bg-primary-minimal": "cui-bg-bg-primary-minimal",
    "highlight-accent": "cui-bg-highlight-accent",
    "highlight-brand": "cui-bg-highlight-brand",
    "highlight-one": "cui-bg-highlight-one",
    "highlight-two": "cui-bg-highlight-two",
    "highlight-three": "cui-bg-highlight-three",
    "highlight-four": "cui-bg-highlight-four",
    "status-positive": "cui-bg-status-positive",
    "status-negative": "cui-bg-status-negative",
    "status-notification": "cui-bg-status-notification",
    "status-alert": "cui-bg-status-alert",
    "rewards-background": "cui-bg-rewards-background"
}

export const tailwindSemanticColorsAsBackground: Record<SemanticColorType | string, string> = {
    "fg-default": "cui-bg-fg-default",
    "fg-moderate": "cui-bg-fg-moderate",
    "fg-subtle": "cui-bg-fg-subtle",
    "fg-minimal": "cui-bg-fg-minimal",
    "fg-inverse": "cui-bg-fg-inverse",
    "fg-primary": "cui-bg-fg-primary",
    "fg-primary-strong": "cui-bg-fg-primary-strong",
    "fg-primary-minimal": "cui-bg-fg-primary-minimal",
    "fg-global-black": "cui-bg-fg-global-black",
    "fg-global-white": "cui-bg-fg-global-white",
    "fg-text-link": "cui-bg-fg-text-link",
    "fg-focus": "cui-bg-fg-focus",
    "fg-focus-inverse": "cui-bg-fg-focus-inverse",
    "bg-base": "cui-bg-bg-base",
    "bg-default": "cui-bg-bg-default",
    "bg-layer-one": "cui-bg-bg-layer-one",
    "bg-layer-two": "cui-bg-bg-layer-two",
    "bg-layer-three": "cui-bg-bg-layer-three",
    "bg-primary": "cui-bg-bg-primary",
    "bg-primary-strong": "cui-bg-bg-primary-strong",
    "bg-primary-minimal": "cui-bg-bg-primary-minimal",
    "highlight-accent": "cui-bg-highlight-accent",
    "highlight-brand": "cui-bg-highlight-brand",
    "highlight-one": "cui-bg-highlight-one",
    "highlight-two": "cui-bg-highlight-two",
    "highlight-three": "cui-bg-highlight-three",
    "highlight-four": "cui-bg-highlight-four",
    "status-positive": "cui-bg-status-positive",
    "status-negative": "cui-bg-status-negative",
    "status-notification": "cui-bg-status-notification",
    "status-alert": "cui-bg-status-alert",
    "rewards-background": "cui-bg-rewards-background",
    "neutrals-transparent": "cui-bg-neutrals-transparent"
}

export const tailwindSemanticBorderColors: Record<SemanticColorType | string, string> = {
    "fg-default": "cui-border-fg-default",
    "fg-moderate": "cui-border-fg-moderate",
    "fg-subtle": "cui-border-fg-subtle",
    "fg-minimal": "cui-border-fg-minimal",
    "fg-inverse": "cui-border-fg-inverse",
    "fg-primary": "cui-border-fg-primary",
    "fg-primary-strong": "cui-border-fg-primary-strong",
    "fg-primary-minimal": "cui-border-fg-primary-minimal",
    "fg-global-black": "cui-border-fg-global-black",
    "fg-global-white": "cui-border-fg-global-white",
    "fg-text-link": "cui-border-fg-text-link",
    "fg-focus": "cui-border-fg-focus",
    "fg-focus-inverse": "cui-border-fg-focus-inverse",
    "bg-base": "cui-border-bg-base",
    "bg-default": "cui-border-bg-default",
    "bg-layer-one": "cui-border-bg-layer-one",
    "bg-layer-two": "cui-border-bg-layer-two",
    "bg-layer-three": "cui-border-bg-layer-three",
    "bg-primary": "cui-border-bg-primary",
    "bg-primary-strong": "cui-border-bg-primary-strong",
    "bg-primary-minimal": "cui-border-bg-primary-minimal",
    "highlight-accent": "cui-border-highlight-accent",
    "highlight-brand": "cui-border-highlight-brand",
    "highlight-one": "cui-border-highlight-one",
    "highlight-two": "cui-border-highlight-two",
    "highlight-three": "cui-border-highlight-three",
    "highlight-four": "cui-border-highlight-four",
    "status-positive": "cui-border-status-positive",
    "status-negative": "cui-border-status-negative",
    "status-notification": "cui-border-status-notification",
    "status-alert": "cui-border-status-alert",
    "rewards-background": "cui-border-rewards-background"
}